import axios from 'axios';
import Endpoints from '../Endpoints';

export const getMatchResults = async (tournamentId) => {
    const { data } = await axios.get(`${Endpoints.Tournament.RESULTS}${tournamentId}/results`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` }
    });
    return data.data;
};

export const verifyMatchResult = async (resultId, status, reviewNote = '') => {
    const { data } = await axios.put(`/api/v1/tournament/results/${resultId}/verify`, { status, reviewNote }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` }
    });
    return data.data;
};

export const distributePrizes = async (tournamentId) => {
    const { data } = await axios.post(`${Endpoints.Tournament.RESULTS}${tournamentId}/distribute-prizes`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` }
    });
    return data.data;
};
